<template>
  <div class="container-box">
    <h2 class="title-type-1">
      VX 관리자 리포트
      <span class="attention-coment-1">
        <v-icon>mdi-alert-circle</v-icon>
        관리자의 경우 조회 옵션을 먼저 선택해야합니다.
      </span>
    </h2>

    <div class="search-box-2">
      <div class="form-row-1">
        <p class="label">조회 기간</p>
        <div class="write-con d-flex align-center">
          <div class="datepicker-type-1">
            <v-icon>mdi-calendar-blank</v-icon>
            <date-range-picker
              v-model="dateRange"
              :locale-data="{
                format: 'yyyy-mm-dd',
                applyLabel: '확인',
                cancelLabel: '취소',
              }"
              opens="right"
              @update="updateDateRange"
            ></date-range-picker>
          </div>
          <div class="ml-2">
            <v-btn
              large
              depressed
              max-height="40px"
              color="#fecd06"
              min-width="104px"
              class="button-type-1"
              @click.prevent="registerReportAdmin"
            >
              조회
            </v-btn>
          </div>
          <div class="ml-2">
            <v-btn
              large
              depressed
              max-height="40px"
              color="#fecd06"
              class="button-type-1"
              @click="exportReportData"
            >
              <v-icon left> mdi-download </v-icon>
              사업부 통계용
            </v-btn>
          </div>
        </div>
      </div>

      <a
        href=""
        class="arrow"
        :class="{ active: searchCell }"
        @click.prevent="searchCell = !searchCell"
      >
        <v-icon>mdi-chevron-down</v-icon>
      </a>

      <v-expand-transition>
        <div v-if="searchCell">
          <div class="form-row-1 mt-4">
            <p class="label">집행 매체</p>
            <div class="write-con">
              <div>
                <v-btn
                  depressed
                  max-height="32px"
                  :color="
                    mediaLists.length !== mediaListsCheck.length
                      ? '#fecd06'
                      : '#eee'
                  "
                  class="button-type-1"
                  @click.prevent="onCheckAll"
                >
                  {{
                    mediaLists.length !== mediaListsCheck.length
                      ? '전체 선택'
                      : '선택 해제'
                  }}
                </v-btn>
              </div>
              <ul class="chx-list-type-1 five mt-2">
                <li v-for="(media, index) in mediaLists" :key="index">
                  <v-checkbox
                    v-model="mediaListsCheck"
                    :value="media.id"
                    :label="media.name"
                    color="#fecd00"
                    off-icon="mdi-checkbox-blank"
                    class="checkbox-type-1"
                    hide-details
                  >
                  </v-checkbox>
                </li>
              </ul>
            </div>
          </div>
          <div class="form-row-1 mt-4">
            <p class="label">광고주/대행사</p>
            <div class="write-con d-flex align-center">
              <div class="search-1">
                <span class="readinput">
                  <v-text-field
                    class="input-custom-2"
                    height="40px"
                    max-width="100px"
                    v-model="adviertierName"
                    hide-details
                    solo
                    readonly
                    @click.prevent="openPopup"
                  ></v-text-field>
                </span>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fecd06"
                  class="button-type-1 ml-2"
                  @click.prevent="openPopup"
                >
                  찾기
                </v-btn>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fff"
                  class="button-type-1 ml-2"
                  @click.stop="adviertierCancel"
                >
                  취소
                </v-btn>
              </div>
            </div>
          </div>
          <div class="form-row-1 mt-4">
            <p class="label">업종별</p>
            <div class="write-con">
              <div class="search-1">
                <div class="sel">
                  <v-select
                    :items="searchSel"
                    label="선택"
                    v-model="searchSelChoice"
                    item-color="#000"
                    class="input-custom-2"
                    height="40px"
                    solo
                    hide-details
                  ></v-select>
                </div>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fff"
                  class="button-type-1 ml-2"
                  @click.stop="sectorCancel"
                >
                  취소
                </v-btn>
              </div>
            </div>
          </div>
          <div class="form-row-1 mt-2">
            <p class="label">캠페인</p>
            <div class="write-con">
              <div class="search-box-1">
                <div class="search-1">
                  <div class="input relative">
                    <v-text-field
                      placeholder="캠페인명"
                      v-model="campaignName"
                      class="input-custom-2"
                      height="40px"
                      solo
                      @keypress="registerReportAdmin"
                    ></v-text-field>
                    <v-btn
                      icon
                      class="btn"
                      @click.prevent="registerReportAdmin"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-expand-transition>
    </div>

    <div v-if="boardLists.length > 0" class="mt-16">
      <div class="d-flex justify-space-between">
        <h3 class="title-type-2">
          <strong>캠페인</strong>
          집행 결과
        </h3>

        <vue-json-to-csv
          :json-data="customLists"
          :csv-title="'캠페인 집행 결과'"
        >
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1"
          >
            <v-icon left> mdi-download </v-icon>
            엑셀 다운로드
          </v-btn>
        </vue-json-to-csv>
      </div>

      <div class="table-wrap">
        <v-data-table
          :headers="boardHeaders"
          :items="boardLists"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          class="board-list-1"
          hide-default-footer
          @page-count="pageCount = $event"
          :expanded.sync="expanded"
          show-expand
          :single-expand="true"
        >
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr>
              <td>
                <router-link
                  :to="{
                    name: 'reportvxCampaign',
                    params: {
                      id: item.id,
                      dateRanges: dateRange,
                      medias: mediaListsCheck,
                    },
                  }"
                >
                  {{ item.name }}
                </router-link>
              </td>
              <td>
                {{ item.advertiser.name }}
              </td>
              <td>
                <span v-if="item.start_at && item.end_at">
                  {{ item.start_at | moment('YYYY.MM.DD') }}
                  ~
                  {{ item.end_at | moment('YYYY.MM.DD') }}
                </span>
                <span v-else>-</span>
              </td>
              <td>
                {{ mediaNames(item.medias) }}
              </td>
              <td>
                {{ mediaInventoryCount(item.medias) }}
              </td>
              <td>
                {{ item.impr | comma }}
              </td>
              <td>
                {{ item.click | comma }}
              </td>
              <td>
                {{ item.ctr ? item.ctr.toFixed(2) + '%' : '-' }}
              </td>
              <td>
                {{ item.status }}
              </td>
              <td>
                <v-btn
                  v-if="item.medias.length > 1"
                  icon
                  @click="expand(!isExpanded)"
                  class="v-data-table__expand-icon"
                  :class="{ 'v-data-table__expand-icon--active': isExpanded }"
                >
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ item }">
            <tr
              v-for="(media, index) in item.medias"
              :key="item.agency.id + '_m' + index"
            >
              <td></td>
              <td></td>
              <td></td>
              <td>{{ media.name }}</td>
              <td>{{ media.inventory_cnt }}</td>
              <td>{{ media.impr | comma }}</td>
              <td>{{ media.click | comma }}</td>
              <td>{{ media.ctr ? media.ctr.toFixed(2) + '%' : '-' }}</td>
              <td></td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="pagination-1">
        <div class="sel-sort">
          <span>페이지당 행개수</span>
          <v-select
            :items="pageSel"
            :label="pageSel[0]"
            v-model="pageSelChoice"
            item-color="#000"
            class="input-custom-1"
            height="40px"
            solo
            @change="itemsPerPage = parseInt($event, 10)"
          ></v-select>
        </div>

        <v-btn
          icon
          :plain="true"
          :ripple="false"
          :disabled="page == 1"
          @click="page = 1"
        >
          <v-icon>mdi-page-first</v-icon>
        </v-btn>

        <v-pagination
          v-model="page"
          :length="pageCount"
          total-visible="10"
          color="transparent"
        ></v-pagination>

        <v-btn
          icon
          :plain="true"
          :ripple="false"
          :disabled="page == pageCount"
          @click="page = pageCount"
        >
          <v-icon>mdi-page-last</v-icon>
        </v-btn>
      </div>
    </div>
    <div v-if="this.searchAdveriser">
      <SearchAdvertiserModal
        v-model="searchAdveriser"
        @select:advertiser="selectAdvertiser"
      />
    </div>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import SearchAdvertiserModal from '~@/modal/SearchAdvertiserModal';
import SystemAlert from '~@/modal/SystemAlert.vue';
import bus from '@/utils/bus.js';
import { listMedia } from '@/api/media';
import { sectors } from '@/api/etc';
import { reportAdminList } from '@/api/report';
import { toISOFormattedDate } from '@/utils/validation';
import moment from 'moment';
import VueJsonToCsv from 'vue-json-to-csv';
import axios from 'axios';

let today = new Date();
today.setHours(0, 0, 0, 0);
today = moment(today).add(-1, 'days').subtract(1, 'months').toDate();
let today2 = moment(today).add(1, 'months');

export default {
  components: {
    DateRangePicker,
    SearchAdvertiserModal,
    SystemAlert,
    VueJsonToCsv,
  },
  data: () => ({
    dateRange: {
      startDate: today,
      endDate: today2,
    },
    mediaLists: [],
    mediaListsCheck: [],
    searchCell: false,
    searchAdveriser: false,
    adviertierName: '',
    adviertierId: '',
    searchSel: [],
    searchSelChoice: '',
    sectorsMap: {},
    campaignName: '',
    expanded: [],
    boardHeaders: [
      { text: '캠페인 명', value: 'name', sortable: false },
      {
        text: '광고주',
        value: 'advertiser.name',
        width: '13%',
        sortable: false,
      },
      { text: '집행 기간', value: '', width: '16%', sortable: false },
      { text: '집행 매체', value: 'medias', width: '14%', sortable: false },
      { text: '상품(지면)수', value: 'medias', width: '9%', sortable: false },
      { text: '노출', value: 'impr', width: '9%', sortable: false },
      { text: '클릭', value: 'click', width: '9%', sortable: false },
      { text: 'CTR', value: 'ctr', width: '7%', sortable: false },
      { text: '상태', value: 'status', width: '7%', sortable: false },
      { text: '', value: 'data-table-expand' },
    ],
    boardLists: [],
    customLists: [],
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    showSystemAlert: false,
    logResult: '',
  }),
  computed: {
    customBoardLists() {
      return this.boardLists;
    },
    mediaNames() {
      return medias => {
        let media_name = medias[0].name;
        if (medias.length > 1) {
          let media_count = medias.length - 1;
          media_name = `${media_name} 외 ${media_count}개`;
        }
        return media_name;
      };
    },
    mediaInventoryCount() {
      return medias => {
        let count = 0;
        medias.forEach(media => {
          count += media.inventory_cnt;
        });
        return count;
      };
    },
  },
  methods: {
    async getListMedia() {
      try {
        const { data } = await listMedia();
        const getListMedia = data.list;

        this.mediaLists = getListMedia;

        const mediaListCheck = getListMedia.reduce((previous, current) => {
          previous.push(current.id);
          return previous;
        }, []);

        this.mediaListsCheck = mediaListCheck;

        this.registerReportAdmin();
      } catch (error) {
        console.log(error.response);
      }
    },
    async getSector() {
      try {
        const { data } = await sectors();
        const list = data.list;
        const listMap = {};
        const names = [];
        (list || []).forEach(item => {
          listMap[item.name] = item;
          names.push(item.name);
        });
        this.sectorsMap = listMap;
        this.searchSel = names;

        bus.$emit('end:spinner');
      } catch (error) {
        console.log(error.response);
        bus.$emit('end:spinner');
      }
    },
    selectAdvertiser(data) {
      this.adviertierName = data.name;
      this.adviertierId = data.id;
    },
    openPopup() {
      this.searchAdveriser = true;
    },
    adviertierCancel() {
      this.adviertierName = '';
      this.adviertierId = '';
    },
    sectorCancel() {
      this.searchSelChoice = '';
    },
    onCheckAll() {
      this.mediaLists.length <= this.mediaListsCheck.length
        ? (this.mediaListsCheck = [])
        : this.mediaLists.forEach(media => {
            this.mediaListsCheck.push(media.id);
          });
    },
    async registerReportAdmin() {
      try {
        let startDate = toISOFormattedDate(this.dateRange.startDate);
        let endDate = toISOFormattedDate(this.dateRange.endDate);

        const mediaLists = this.mediaListsCheck.reduce((previous, current) => {
          previous.push({ id: current });
          return previous;
        }, []);

        if (mediaLists.length <= 0) {
          this.showSystemAlert = true;
          this.logResult = '집행 매체를 최소 1개 선택해주세요.';
          return;
        }

        bus.$emit('start:spinner');

        const resultData = () => {
          const result = {
            start_at: startDate,
            end_at: endDate,
          };
          if (mediaLists.length > 0) result.medias = mediaLists;
          if (this.adviertierId)
            result.advertisers = [{ id: this.adviertierId }];
          if (this.searchSelChoice)
            result.sector_id = this.sectorsMap[this.searchSelChoice].id;
          if (this.campaignName) result.name = this.campaignName;
          return result;
        };

        const { data } = await reportAdminList(resultData());

        if (data.list.length > 0) {
          this.boardLists = data.list;
          this.boardLists.map(item => {
            if (item.is_valid === 'Y') {
              if (this.$moment(item.start_at) > this.$moment(new Date())) {
                item.status = '대기중';
              } else if (this.$moment(item.end_at) > this.$moment(new Date())) {
                item.status = '진행중';
              } else {
                item.status = '종료';
              }
            } else {
              item.status = '종료';
            }

            item.medias.forEach(media => {
              let impr = 0,
                click = 0;
              media.inventories.forEach(inventory => {
                inventory.days.forEach(day => {
                  impr += day.impr;
                  click += day.click;
                });
              });

              media.impr = impr;
              media.click = click;
              media.ctr = (click / impr) * 100;
            });
          });

          const exel = [];
          this.boardLists.forEach(da => {
            exel.push({
              캠페인명: da.name,
              광고주: da.advertiser.name,
              '집행 매체': da.medias[0].name,
              '집행 기간': `${moment(da.start_at).format(
                'YYYY.MM.DD',
              )} ~ ${moment(da.end_at).format('YYYY.MM.DD')}`,
              '상품(지면)수': da.medias[0].inventory_cnt,
              노출: da.impr,
              클릭: da.click,
              CTR: da.ctr ? da.ctr.toFixed(2) + '%' : '-',
              상태: da.status,
            });
          });
          this.customLists = exel;
        } else {
          this.showSystemAlert = true;
          this.logResult = '조회된 목록이 없습니다.';
          this.boardLists = [];
        }
        bus.$emit('end:spinner');
      } catch (error) {
        console.log(error);
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },

    async exportReportData() {
      let startDate = toISOFormattedDate(this.dateRange.startDate);
      let endDate = toISOFormattedDate(this.dateRange.endDate);
      let byDate = this.$moment(this.dateRange.endDate).subtract(1, 'months'); // endDate로부터 1개월 계산
      if (this.dateRange.startDate >= byDate) {
        await axios({
          method: 'POST',
          url: `${process.env.VUE_APP_API_URL}api/reports/admin/download`,
          responseType: 'arraybuffer',
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
          },
          data: {
            start_at: startDate,
            end_at: endDate,
          },
        }).then(response => {
          console.log('response', response);
          const contentDisposition = response.headers['content-disposition'];
          const filename = contentDisposition
            .split(';')
            .filter(r => r.includes('filename'))[0]
            .split('=')[1];
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers['content-type'],
            }),
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        });
      } else {
        this.showSystemAlert = true;
        this.logResult = '조회기간은 최대 1개월까지 입니다.';
      }
    },
    updateDateRange() {
      this.dateRange.startDate.setHours(0, 0, 0, 0);
      this.dateRange.endDate.setHours(0, 0, 0, 0);
    },
  },
  async created() {
    bus.$emit('start:spinner');
    await this.getSector();
    await this.getListMedia();
  },
};
</script>

<style></style>
